import { useState } from "react";
import { DashboardStorePanelFilterSectionExport } from "./DashboardStorePanelFilterSectionExport";
import RadioButton from "./RadioButton";
import InputData from "./InputData";
import ButtonIconH from "./ButtonIconH";
import "../css/ReportPopup.css";

export function BasicOptometryReportPopup({
  createPopupQuestion,
  removePopupQuestion,
  onExport,
  onGenerateOfficialPrescription = () => {},
  onClose,
}) {
  const [options, setOptions] = useState({
    record: 0, // 0: current, 1: history, 2: official prescription
    observations: true,
    email: "",
  });
  const [errorEmail, setErrorEmail] = useState(false);

  // console.log("options: ", options);

  const checkEmail = () => {
    if (errorEmail || options.email === "") {
      createPopupQuestion(
        "Por favor, introduzca un email correcto.",
        () => {
          setErrorEmail(false);
          removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  };

  return (
    <div className="popup-container" style={{ zIndex: 11 }}>
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">
            Informe de optometría básica
          </span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon" />
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div
            className="container-panel"
            style={{ display: "flex", flexDirection: "column", gap: 20 }}
          >
            <div
              className="opt-table-content grid-5"
              id="basic-optometry-report-grid"
            >
              <div className="cell cell-start-content">
                <div
                  className="data-field"
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      record: 0,
                    }));
                  }}
                >
                  <RadioButton active={options.record === 0}></RadioButton>
                  <span>Ficha actual</span>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                <div
                  className="data-field"
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      record: 1,
                    }));
                  }}
                >
                  <RadioButton active={options.record === 1}></RadioButton>
                  <span>Histórico</span>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                <div
                  className="data-field"
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      record: 2,
                    }));
                  }}
                >
                  <RadioButton active={options.record === 2}></RadioButton>
                  <span>Receta oficial CGCOO</span>
                </div>
              </div>
              {options.record !== 2 && (
                <>
                  <div className="cell cell-start-content">Observaciones</div>
                  <div className="cell cell-start-content combined-cells-4">
                    <div className="radio-ops-container" style={{ gap: 20 }}>
                      <div
                        className="data-field"
                        onClick={() => {
                          setOptions((prev) => ({
                            ...prev,
                            observations: true,
                          }));
                        }}
                      >
                        <RadioButton active={options.observations}></RadioButton>
                        <span>Sí</span>
                      </div>
                      <div
                        className="data-field"
                        onClick={() => {
                          setOptions((prev) => ({
                            ...prev,
                            observations: false,
                          }));
                        }}
                      >
                        <RadioButton active={!options.observations}></RadioButton>
                        <span>No</span>
                      </div>
                    </div>
                  </div>
                  <div className="cell cell-start-content combined-cells-5">
                    <div className="data-field" style={{ width: "100%" }}>
                      <span>Email</span>
                      <InputData
                        type="type-email"
                        size={0}
                        input={options.email}
                        onChange={(e) => {
                          setOptions((prev) => ({
                            ...prev,
                            email: e,
                          }));
                        }}
                        onMalformed={() => setErrorEmail(true)}
                        error={errorEmail}
                      ></InputData>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="popup-buttons" style={{ justifyContent: "center" }}>
              {options.record === 2 ? (
                <ButtonIconH
                  text="Generar receta"
                  onClick={() => {
                    onGenerateOfficialPrescription(options);
                  }}
                ></ButtonIconH>
              ) : (
                <>
                  <ButtonIconH
                    text="Enviar email"
                    onClick={() => {
                      onExport(options);
                    }}
                  ></ButtonIconH>
                  <ButtonIconH
                    text="Exportar PDF"
                    onClick={() => {
                      onExport(options);
                    }}
                  ></ButtonIconH>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
